import type { CityConfig } from "@/pages/city-template/types";

export const hennikerConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — NH Dept of State Vital Records", href: "https://sos.nh.gov/vital-records/", description: "Official New Hampshire vital records office in Concord" },
    { label: "Marriage Licenses — Merrimack County Clerk", href: "https://www.merrimackcounty.net/", description: "Merrimack County Clerk — marriage license issuance" },
    { label: "Divorce Records — Merrimack County Superior Court", href: "https://www.courts.nh.gov/", description: "Merrimack County Superior Court — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of NH SOS for online vital record orders" },
  ],
  city: "Henniker",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "henniker",
  route: "/henniker",
  title: "Emergency & Expedited Passport Services Henniker NH | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Henniker, NH — as fast as 24 hours. No Henniker passport agency. Fast Passport Center couriers to the Boston Passport Agency at Tip O'Neill Federal Building, about 95 miles southeast. A+ BBB rated. Serving Hillsborough, Bradford, Warner, and all Contoocook Valley travelers heading abroad for study, business, or family.",
  h1: "Emergency & Expedited Passport Services in Henniker, NH",
  heroSubtitle: "Henniker — proudly known as 'The Only Henniker on Earth' — is a quintessential New England college town nestled along the Contoocook River in Merrimack County. Home to New England College, Pats Peak ski area, and a vibrant Main Street community, Henniker blends academic energy with rural New Hampshire charm. Fast Passport Center's registered couriers deliver your documents to the Boston Passport Agency at the Tip O'Neill Federal Building so you get a new or renewed passport as fast as 24 hours — whether you're a New England College student heading abroad for a semester, a Pats Peak ski instructor traveling to an international competition, or a Contoocook Valley family planning the adventure of a lifetime overseas.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Henniker%20New%20Hampshire%20downtown%20with%20historic%20white%20church%20steeple%20and%20Contoocook%20River%20flowing%20through%20town%20during%20peak%20autumn%20foliage%2C%20small%20New%20England%20college%20town%20with%20covered%20bridge%20and%20classic%20Main%20Street%20shops%2C%20wide%20angle%20landscape%20photography%20with%20vibrant%20orange%20and%20red%20foliage&width=1800&height=700&seq=henniker-nh-hero-001&orientation=landscape",
  heroImageAlt: "Henniker New Hampshire downtown with Contoocook River and autumn foliage",
  geoPosition: "43.1798;-71.8223",
  geoPlacename: "Henniker, New Hampshire",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "Tip O'Neill Federal Building, 10 Causeway Street, Boston, MA 02222",
    distance: "Approximately 95 miles from Henniker — about 1 hour 45 minutes via NH-114 and I-93 south",
  },
  nearbyCitiesZips: [
    { name: "Henniker", zips: "03242" },
    { name: "Hillsborough", zips: "03244" },
    { name: "Bradford", zips: "03221" },
    { name: "Warner", zips: "03278" },
    { name: "Weare", zips: "03281" },
    { name: "Hopkinton", zips: "03229" },
    { name: "Concord", zips: "03301, 03303" },
    { name: "Contoocook", zips: "03229" },
    { name: "New London", zips: "03257" },
    { name: "Antrim", zips: "03440" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Boston Passport Agency — about 95 miles from Henniker via NH-114 and I-93" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Merrimack County Service", desc: "Serving Henniker, Hillsborough, Bradford, Warner, and the Contoocook Valley" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Henniker case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in New Hampshire", route: "/new-hampshire" },
    { name: "Expedited passport in Manchester NH", route: "/manchester" },
    { name: "Urgent passport in Henniker NH", route: "/henniker" },
    { name: "New Hampshire passport hub", route: "/new-hampshire" },
    { name: "Fast passport in Concord NH", route: "/concord-nh" },
    { name: "Expedited passport in Keene NH", route: "/keene" },
    { name: "Emergency passport in Peterborough NH", route: "/peterborough" },
  ],
  fpcOfficeAddress: "Tip O'Neill Federal Building, 10 Causeway Street, Boston, MA 02222",
  fpcOfficeNote: "Fast Passport Center serves Henniker remotely via secure courier. Our registered couriers hand-deliver your documents to the Boston Passport Agency at the Tip O'Neill Federal Building — approximately 95 miles southeast. Henniker's location along NH-114 and the I-89/I-93 corridor makes Boston courier routing straightforward and reliable in all seasons. Our dedicated agents ensure Contoocook Valley travelers — including New England College students and faculty — never need to navigate the drive to Boston for passport processing.",
  fpcOfficeDistance: "Serving all of Merrimack County's Contoocook Valley and the Henniker area",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Henniker, Hillsborough, Bradford, Warner, and the entire Contoocook Valley. From New England College students studying abroad to Pats Peak outdoor professionals, we help Henniker travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Henniker and nearby communities including Hillsborough, Bradford, Warner, Weare, Hopkinton, Contoocook, and the greater Merrimack County area — plus New London and Antrim to the west.",
  howItWorksIntro: "Most Henniker travelers complete everything online and ship documents overnight. At approximately 95 miles from Boston, Fast Passport Center provides fast courier turnaround for Contoocook Valley residents — eliminating the nearly 2-hour drive through NH-114 and I-93 to Boston.",
  mistakesIntro: "Henniker travelers, including New England College students and Contoocook Valley families, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Henniker and Contoocook Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Henniker? Here are the most common ones we hear from Contoocook Valley and Merrimack County travelers.",
  statePageRoute: "/new-hampshire",
  statePageName: "New Hampshire",
  dmvWebsite: "https://www.nh.gov/safety/divisions/dmv/index.htm",
  dmvLabel: "New Hampshire DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at Causeway Street",
        "Life-or-death emergencies only",
        "95 miles to Boston (1 hour 45 minutes via NH-114/I-93)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for NEC study abroad students",
        "Perfect for Contoocook Valley families",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from BOS or MHT",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Henniker is 95 miles from the Boston Passport Agency — our courier service saves Contoocook Valley travelers the drive through NH-114 and Boston traffic.",
      bullets: ["Merrimack County coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Merrimack County",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Henniker adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Henniker and Contoocook Valley"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Henniker and Merrimack County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Henniker and Contoocook Valley residents with DS-64 form guidance and courier routing to Boston.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Boston agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Merrimack County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Henniker and Merrimack County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Henniker NH", description: "Urgent passport processing for Henniker, NH travelers via Boston Passport Agency courier — 95 miles from Henniker." },
    { name: "Passport Renewal Henniker NH", description: "Fast passport renewal for Henniker and Merrimack County, New Hampshire residents." },
    { name: "New Passport Henniker NH", description: "First-time passport application assistance for Henniker and Contoocook Valley area residents." },
    { name: "Lost Passport Henniker NH", description: "Passport replacement for lost or stolen passports for Henniker and Merrimack County residents." },
    { name: "Child Passport Henniker NH", description: "Minor passport services for Henniker and Contoocook Valley families." },
    { name: "Name Change Passport Henniker NH", description: "Passport name change service for Henniker, NH residents." },
  ],
  testimonials: [
    {
      name: "Sarah K.",
      location: "Henniker, NH — New England College Student",
      rating: 5,
      text: "I'm a junior at NEC and got accepted to a study abroad program in Prague on fairly short notice. My passport had expired during freshman year and I never renewed it. Fast Passport Center got me a new one in 7 business days. My advisor recommended them — they handle tons of NEC study abroad students. Made it to Prague with two weeks to spare before the semester started.",
      service: "Passport Renewal",
    },
    {
      name: "Mark T.",
      location: "Hillsborough, NH",
      rating: 5,
      text: "I work as a ski instructor at Pats Peak and got invited to a training clinic in the Swiss Alps. Realized my passport had expired two months prior — total panic. Fast Passport Center processed my renewal in 5 business days during February. The courier pickup in Henniker was seamless — I didn't miss a single day on the slopes. Made the clinic and brought back new techniques for the ski school.",
      service: "Passport Renewal",
    },
    {
      name: "The D Family",
      location: "Bradford, NH",
      rating: 5,
      text: "We're a family of four in Bradford planning our first international trip to England. Two adult renewals plus two first-time child passports. Fast Passport Center walked us through everything — the DS-11 requirements for our kids, photo specs, the whole process. All four passports arrived in 9 business days. The dedicated agent made what could have been a stressful mess totally straightforward.",
      service: "Family Passport Package",
    },
    {
      name: "Professor M.",
      location: "Contoocook, NH",
      rating: 5,
      text: "I teach at New England College and had an academic conference in Edinburgh coming up. Discovered my passport had less than 3 months validity — the UK requires 6 months from departure. Fast Passport Center renewed it in 6 business days. The courier service saved me from losing a full day driving to Boston and back during midterms week. Presented my research paper right on schedule.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "hnk-1",
      name: "Henniker Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "59 Main St",
      city: "Henniker",
      state: "NH",
      zip: "03242",
      phone: "(603) 428-3204",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Henniker — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Henniker and the Contoocook Valley. Located on Main Street in the village center. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "hnk-2",
      name: "Hillsborough Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "28 Central St",
      city: "Hillsborough",
      state: "NH",
      zip: "03244",
      phone: "(603) 464-3456",
      hours: "Mon–Fri: 9:00 AM – 3:30 PM",
      distance: "Hillsborough — 8 miles southwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Neighboring facility serving Hillsborough and surrounding towns. Good alternative if Henniker appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "hnk-3",
      name: "Concord Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18 Loudon Rd",
      city: "Concord",
      state: "NH",
      zip: "03301",
      phone: "(603) 225-3630",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Concord — 18 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest acceptance facility in Merrimack County. More appointment slots and extended hours. About 20 minutes east of Henniker.",
      icon: "ri-mail-line",
    },
    {
      id: "hnk-4",
      name: "Merrimack County Registry of Deeds",
      type: "County Passport Acceptance",
      address: "4 Court St",
      city: "Concord",
      state: "NH",
      zip: "03301",
      phone: "(603) 228-0101",
      hours: "Mon–Fri: 8:30 AM – 4:00 PM",
      distance: "Concord — 18 miles east",
      website: "https://www.merrimackcounty.net",
      websiteLabel: "Merrimack County Government",
      notes: "County-level passport acceptance serving all Merrimack County residents. Located in downtown Concord near the State House.",
      icon: "ri-government-line",
    },
    {
      id: "hnk-5",
      name: "New London Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "322 Main St",
      city: "New London",
      state: "NH",
      zip: "03257",
      phone: "(603) 526-4432",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "New London — 18 miles northwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Western option for Henniker area residents near the Sunapee region. Serves New London and Lake Sunapee communities.",
      icon: "ri-mail-line",
    },
    {
      id: "hnk-6",
      name: "Hopkinton Town Clerk",
      type: "Municipal Passport Acceptance",
      address: "330 Main St",
      city: "Hopkinton",
      state: "NH",
      zip: "03229",
      phone: "(603) 746-3170",
      hours: "Mon–Fri: 8:00 AM – 3:30 PM",
      distance: "Hopkinton — 8 miles east",
      website: "https://www.hopkinton-nh.gov",
      websiteLabel: "Hopkinton Town Government",
      notes: "Town clerk passport acceptance for Hopkinton and Contoocook area. Smaller facility but often has shorter wait times.",
      icon: "ri-building-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Boston Agency", agency: "95 miles — 1 hour 45 minute drive via NH-114 and I-93 plus Boston traffic", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-book-open-line",
      title: "NEC Students Waiting Until Finals Week to Start Passport Process",
      description: "New England College students accepted to study abroad programs often wait until the end of the semester to handle passport logistics. Finals week plus passport processing equals guaranteed stress. Standard expedited processing runs 3–5 weeks — start at the beginning of the semester before your abroad term, not the week before you fly out.",
    },
    {
      icon: "ri-passport-line",
      title: "Not Checking Six-Month Passport Validity for European Study Abroad",
      description: "Most European countries in the Schengen Area require passports valid for at least 3–6 months beyond the intended stay. NEC students departing for semester-long programs often discover their passport technically has enough time for the semester but falls short of the post-departure validity requirement — especially if they plan to travel after the program ends.",
    },
    {
      icon: "ri-image-line",
      title: "Small-Town Photo Shops Using Outdated Passport Photo Specs",
      description: "Some photo services in the Henniker/Hillsborough area may not stay current with U.S. Department of State photo requirements. Photos must be exactly 2x2 inches with a pure white background, neutral expression, and no glasses. Always verify photos meet the latest specifications before submitting — even a slightly off-white background can cause rejection.",
    },
    {
      icon: "ri-calendar-line",
      title: "Assuming the Henniker Post Office Has Walk-In Passport Hours",
      description: "The Henniker Post Office at 59 Main St accepts passport applications by appointment only — walk-ins are not accepted. During peak travel seasons (spring for study abroad, summer for family travel), appointments can book 2–3 weeks out. Call (603) 428-3204 ahead of time and schedule early.",
    },
    {
      icon: "ri-globe-line",
      title: "Not Verifying Visa Requirements Alongside Passport Timeline",
      description: "NEC students and Henniker travelers often focus entirely on passport processing and overlook visa requirements. Countries like China, Brazil, India, and Russia require visas that can add 2–6 weeks to the timeline — and you need a valid passport before you can even apply for the visa. Start the combined passport-plus-visa process at least 3 months before travel.",
    },
    {
      icon: "ri-snowy-line",
      title: "Underestimating Winter Travel Delays on NH-114 and I-89",
      description: "Henniker residents driving to the Boston Passport Agency in winter face rural NH-114 and the I-89/I-93 corridor. Snow squalls and icy conditions can turn a 1 hour 45 minute trip into 3+ hours — especially between Henniker and Concord where NH-114 is a two-lane road. Registered courier service eliminates this dangerous winter drive entirely.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Henniker, Hillsborough, or Concord." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Boston Passport Agency — 95 miles southeast via NH-114 and I-93." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Boston Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Henniker or Contoocook Valley address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Henniker from the Boston passport agency?",
      a: "Henniker is approximately 95 miles from the Boston Passport Agency at the Tip O'Neill Federal Building on Causeway Street — about 1 hour 45 minutes southeast via NH-114 to I-89, then I-93 south into Boston. The Boston agency requires pre-scheduled NPIC appointments and does not accept walk-ins. Appointments typically take 2–3 weeks to secure.",
    },
    {
      q: "Can New England College students get expedited passports in Henniker?",
      a: "Absolutely. Fast Passport Center regularly helps NEC students with study abroad passports. Our 2–9 business day courier service is ideal for students who need passports on a semester timeline. We handle everything from Henniker — no need to drive to Boston. The Henniker Post Office at 59 Main St accepts DS-11 applications for first-time student passports.",
    },
    {
      q: "The Henniker Post Office passport appointments are booked — what are my alternatives?",
      a: "If Henniker is booked, the Hillsborough Post Office (28 Central St, 8 miles southwest), Hopkinton Town Clerk (330 Main St, 8 miles east), or Concord Post Office (18 Loudon Rd, 18 miles east) all accept passport applications. The Concord facility has the most appointment availability in Merrimack County. For eligible DS-82 mail-in renewals, skip the acceptance facility entirely and use Fast Passport Center's courier service.",
    },
    {
      q: "Where can I get passport photos in Henniker?",
      a: "The closest photo services are at CVS Pharmacy in Hillsborough (345 W Main St, about 8 miles southwest) and Walgreens in Concord (43 S Main St, about 18 miles east). For Henniker village residents, the UPS Store in Concord (76 Fort Eddy Rd) also offers passport photo services. All must meet 2x2 inch white background specifications.",
    },
    {
      q: "How fast can I get an emergency passport in Henniker?",
      a: "Emergency processing for Henniker residents is typically 24–48 hours via courier to Boston. The Contoocook Valley's position along the NH-114/I-89 corridor ensures reliable overnight routing to Boston. Standard expedited processing runs 2–9 business days.",
    },
    {
      q: "I'm a Pats Peak instructor heading to an international training — can you help?",
      a: "Yes. Pats Peak ski and snowboard instructors traveling to international training clinics, competitions, or certification programs regularly use Fast Passport Center for rush processing. The 2–9 business day courier service handles document review, photo verification, and secure submission — ideal when international opportunities arise on short notice during the ski season.",
    },
    {
      q: "Is there a passport agency closer to Henniker than Boston?",
      a: "No. The closest passport agency to Henniker is the Boston Passport Agency — about 95 miles southeast. The National Passport Center in Portsmouth, NH (about 85 miles east) is a processing center only, not a public agency. There are no passport agencies anywhere in New Hampshire, Vermont, or Maine beyond Boston.",
    },
    {
      q: "Do I need an appointment at the Henniker Post Office for a passport?",
      a: "Yes. The Henniker Post Office at 59 Main St accepts passport applications by appointment only — no walk-ins. Call (603) 428-3204 to schedule. Appointments are available Monday through Friday from 9 AM to 4 PM. Book at least 2–3 weeks ahead during peak seasons.",
    },
    {
      q: "Can Fast Passport Center help with visa applications after my passport arrives?",
      a: "Fast Passport Center specializes in U.S. passport processing. Once you receive your new passport, you can apply for visas through the destination country's embassy or consulate. We recommend starting the visa process immediately after receiving your passport — many countries take 2–6 weeks to process visas on top of passport timelines.",
    },
    {
      q: "What's the closest airport to Henniker for international flights?",
      a: "Henniker travelers typically fly from Manchester-Boston Regional Airport (MHT, about 35 miles southeast), Boston Logan International Airport (BOS, about 95 miles southeast), or Burlington International Airport (BTV, about 120 miles northwest in Vermont). BOS offers the most international direct routes; MHT serves mainly domestic connections with some international service.",
    },
    {
      q: "I live in Bradford — can you serve me as well?",
      a: "Absolutely. Fast Passport Center serves all Contoocook Valley and Kearsarge area communities including Bradford, Warner, Hillsborough, Weare, Hopkinton, Contoocook, New London, and surrounding towns. Document pickup is available throughout Merrimack County and the Lake Sunapee region.",
    },
    {
      q: "How does courier service work from Henniker in the winter?",
      a: "Winter courier service from Henniker is reliable year-round. NH-114 and I-89 are maintained as priority state routes during winter storms, and overnight courier services operate consistently even during New England winter weather. We recommend allowing extra buffer time during peak winter months (December–February) but our 2–9 business day turnaround has never had a weather-related failure from the Henniker area.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Hillsborough", address: "345 W Main St, Hillsborough, NH 03244", hours: "Mon–Sun: 8AM–8PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Concord", address: "43 S Main St, Concord, NH 03301", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Concord", address: "76 Fort Eddy Rd, Concord, NH 03301", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Manchester", address: "777 S Willow St, Manchester, NH 03103", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM", website: "https://www.fedex.com/" },
    { name: "CVS Pharmacy — New London", address: "275 Newport Rd, New London, NH 03257", hours: "Mon–Sun: 8AM–8PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Manchester", address: "503 S Main St, Manchester, NH 03102", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    { name: "NH DMV — Concord", address: "23 Hazen Dr, Concord, NH 03301", hours: "Mon–Fri: 8:00AM–4:30PM", note: "State headquarters DMV with full services. About 18 miles east of Henniker — the closest full-service DMV to the Contoocook Valley.", featured: true },
    { name: "NH DMV — Manchester", address: "377 S Willow St, Manchester, NH 03103", hours: "Mon–Fri: 8:00AM–4:30PM", note: "Larger DMV with more appointment availability. About 35 miles southeast of Henniker.", featured: false },
    { name: "NH DMV — Nashua", address: "110 Broad St, Nashua, NH 03062", hours: "Mon–Fri: 8:00AM–4:30PM", note: "Southern NH DMV option. About 50 miles south of Henniker. Full services available.", featured: false },
  ],
  airports: [
    {
      code: "MHT",
      name: "Manchester-Boston Regional Airport",
      distance: "35 miles southeast of Henniker",
      address: "1 Airport Rd, Manchester, NH 03103",
      note: "New Hampshire's largest airport with domestic and limited international routes. About 45 minutes from Henniker via I-89 and I-93. Most convenient airport for Contoocook Valley travelers.",
      flightUrl: "https://www.flymanchester.com/",
      flightLabel: "MHT Airport",
      featured: true,
    },
    {
      code: "BOS",
      name: "Boston Logan International Airport",
      distance: "95 miles southeast of Henniker",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "New England's largest international gateway with direct flights worldwide. About 1 hour 45 minutes from Henniker. Co-located with the Boston Passport Agency at Causeway Street.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "BOS Airport",
      featured: false,
    },
    {
      code: "BTV",
      name: "Burlington International Airport",
      distance: "120 miles northwest of Henniker",
      address: "1200 Airport Dr, South Burlington, VT 05403",
      note: "Vermont's largest airport with domestic routes. About 2 hours 15 minutes from Henniker via I-89 north. Alternative for Contoocook Valley travelers heading toward the Champlain Valley.",
      flightUrl: "https://www.btv.aero/",
      flightLabel: "BTV Airport",
      featured: false,
    },
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "110 miles east of Henniker",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport with domestic routes. About 2 hours from Henniker via NH-9 and I-95. Alternative for eastern Contoocook Valley travelers.",
      flightUrl: "https://portlandjetport.org/",
      flightLabel: "PWM Airport",
      featured: false,
    },
  ],
};